module.exports = __webpack_public_path__ + "img/repairs.468b10fb.png";